<template>
  <VirtualList
    :data-key="dataKey"
    :data-sources="nodes"
    :data-component="VirtualItem"
    item-class="tree-item"
    class="virtual-list"
    :extra-props="{
      formula,
    }"
    :keeps="200"
    :estimate-size="66"
    @onTagClick="$emit('onTagClick', $event)"
  />
  <!-- <template v-else>
      <div
        v-for="(node, index) in nodes"
        :key="index"
        class="tree-item"
      >
        <CriterionItem
          :criterion="node"
          :formula="formula"
          class="here"
          @onTagClick="$emit('onTagClick', $event)"
        />
      </div>
    </template> -->
</template>

<script>
import CriterionVirtualItem from './CriterionVirtualItem'
// import CriterionItem from './CriterionItem'
import VirtualList from 'vue-virtual-scroll-list'

export default {
    name: 'CriteriaListTree',

    components: {
        // eslint-disable-next-line vue/no-unused-components
        CriterionVirtualItem,
        // eslint-disable-next-line vue/no-unused-components
        // CriterionItem,
        VirtualList,
    },

    props: {
        formula: {
            type: Object,
            required: true
        },
        nodes: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            activeDepth: 0,
            VirtualItem: CriterionVirtualItem,
        }
    },

    computed: {
        dataKey() {
            return this.nodes[0]?._id ? '_id' : 'id'
        }
    }
}
</script>

<style>
.criteria-tree-container.is-scrollable, .criteria-categories.is-scrollable {
  height: 100%;
}
.criteria-tree-container.is-scrollable .virtual-tree, .criteria-categories.is-scrollable .virtual-tree{
  padding-right: 0;
}
.virtual-list {
    height: 67vh;
    overflow-y: auto;
}
</style>
